module.exports = __webpack_public_path__ + "img/sdk.ddbdba46.png";